import bookDialog from "./bookDialog/bookDialog.html";
import bookDialogCtrl from "./bookDialog/bookDialog.controller";

import assignBackupDialog from "./assignBackupDialog/assignBackupDialog.controller";
import assignBackupDialogCtrl from "./assignBackupDialog/assignBackupDialog.html";

import captainInfoDialog from "./captainInfo/captainInfo.html";
import captainInfoDialogCtrl from "./captainInfo/captainInfo.controller";

import vendorInfoDialog from "./vendorInfo/vendorInfo.html";
import vendorInfoDialogCtrl from "./vendorInfo/vendorInfo.controller";

import assignBusDialogTemplate from "./assignBusDialog/assignBusDialog.html";
import assignBusDialogCtrl from "./assignBusDialog/assignBusDialog.controller";

import cancelReasonsDialog from "./cancelReasons/cancelReasons.html";
import cancelReasonsDialogCtrl from "./cancelReasons/cancelReasons.controller";

import transferBookingsUpdatedDialog from "./transferBookingsUpdated/transferBookingsUpdated.html";
import transferBookingsUpdatedDialogCtrl from "./transferBookingsUpdated/transferBookingsUpdated.controller";

import unAssignCaptainDialog from "./unAssignCaptain/unAssignCaptain.html";
import unAssignCaptainDialogCtrl from "./unAssignCaptain/unAssignCaptain.controller";

import DialogTemplate from "../../components/addItem/dialog/dialog.html";
import DialogController from "../../components/addItem/dialog/dialog.controller";

import constants from "../../core/constants";
import isNil from "lodash/fp/isNil";
import isObject from "lodash/fp/isObject";
import polyline from "google-polyline";

import conflictingDialogCtrl from "../../components/conflictingDialog/conflictingDialog.controller";
import conflictingDialog from "../../components/conflictingDialog/conflictingDialog.html";
class Controller {
  constructor(
    $injector,
    $stateParams,
    $mdDialog,
    $timeout,
    $transitions,
    Lists
  ) {
    "ngInject";
    this.counter = 0;
    this.Lists = Lists;
    this.$timeout = $timeout;
    this.$mdDialog = $mdDialog;
    this.$stateParams = $stateParams;
    this.$transitions = $transitions;
    this.Ride = $injector.get("Ride");
    this.Lists = $injector.get("Lists");
    this.Socket = $injector.get("Socket");
    this.Events = $injector.get("Events");
    this.Messages = $injector.get("Messages");
    this.Bookings = $injector.get("Bookings");
    this.Company = $injector.get("Company");
    this.Contractor = $injector.get("Contractor");
    this.User = $injector.get("User");
    this.InvoiceItem = $injector.get("InvoiceItem");
    this.RealtimeRide = $injector.get("RealtimeRide");
    this.Authentication = $injector.get("Authentication");
    this.RideTransforms = $injector.get("RideTransforms");
    this.RideBackupsTransform = $injector.get("RideBackupsTransform");
    this.BookingsTransforms = $injector.get("BookingsTransforms");
    this.sections = $injector.get("Sections").routesSections;
    // Get ride category per city
    this.City = $injector.get("City");
    this.CityHandler = $injector.get("CityHandler");
    this.dashboardCity = this.CityHandler.get();

    this.defaultRideStatus = this.RideTransforms.rideStatus;
    this.rideTypes = this.Lists.all.rideTypes;
    this.bookingsFilters = this.BookingsTransforms.filters;
    this.bookingsResourceParams = {
      ride: this.$stateParams.id,
      isCityRequired: false,
    };
    this.bookingResourceActions = $injector.get(
      "ActionLists"
    ).all.bookingActions;

    this.onUpdate = this.Events.getUpdateEvent("ride");
    this.onArrived = this.Events.getUpdateEvent("rideArrive");
    this.onDeparted = this.Events.getUpdateEvent("rideDepart");
    this.realtimeEvent = this.Events.getUpdateEvent("rideRealtime");
    this.skipStationEvent = this.Events.getUpdateEvent("rideStation");

    this.connectionStatusEvent = this.Events.getUpdateEvent("connectionStatus");
    this.activityParams = {
      resourceType: "Ride",
      resource: $stateParams.id,
      limit: 0,
    };
    this.Contracts = $injector.get("Contracts");
    this.CorporateTransforms = $injector.get("CorporateTransforms");
    this.rideID = $stateParams.id;
    this.price = "";
    this.bookingsStatus = [];
    this.isDynamicallyPricedText = "Dynamic Pricing";

    this.showSuccessNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;
  }

  $onInit() {
    const rideLocationEvent = this.Events.getRideLocationEvent(
      this.$stateParams.id
    );
    this.showConflictDialog = (captainConflict) => {
      const timezone = this.ride.city.timezone;
      this.$mdDialog.show({
        controller: conflictingDialogCtrl,
        controllerAs: "$ctrl",
        template: conflictingDialog,
        locals: {
          captainConflict,
          timezone,
        },
      });
    };
    const socket = this.Socket.dashboard();
    const connectSocket = () => socket.connect();
    const connectionStatusSuccess = {
      hasError: false,
      message: "Connected.",
      icon: "check_circle",
    };
    const connectionStatusError = {
      hasError: true,
      message: "Disconnected, Please reload.",
      icon: "warning",
      reconnectSocket: connectSocket,
    };

    const onUpdate = (options) => {
      const params = {};
      params[options.key] = options.value
        ? options.value
        : options.name
        ? options.name._id
        : null;
      if (options.key === "captain_price") {
        params[options.key] =
          options.value === null
            ? options.value
            : options.value * constants.currencyBy;
      }
      if (
        options.key === "arrival_time_allowance" ||
        options.key === "departure_time_allowance"
      ) {
        params[options.key] = options.value * constants.fromMinToMilli;
      }

      this.Ride[options.method](this.$stateParams.id, params).$promise.then(
        (response) => {
          this.ride = this.RideTransforms.justify(response);
          this.Events.emit(
            this.showSuccessNotificationEvent,
            this.Messages.updateMessage("ride", options.key)
          );
        },
        (response) => {
          if (response.data.captainConflict) {
            const captainConflict = response.data.captainConflict;
            this.showConflictDialog(captainConflict);
          }
          this.Events.emit(this.errorEvent, response.data);
        }
      );
    };
    const getBooking = () => {
      this.Bookings.getAll({ ride: this.$stateParams.id }).$promise.then(
        (response) => {
          this.counter++;
          this.bookings = this.BookingsTransforms.justify(
            response.hits,
            this.$stateParams.id
          );
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    };

    const getConfirmDialog = (title, confirmClick) =>
      this.$mdDialog
        .confirm()
        .title(title)
        .ok(confirmClick || "Ok")
        .cancel("Cancel");

    this.addExtraSeat = () => {
      const extraSeatConfirm = getConfirmDialog(
        this.Messages.singles.extraSeat,
        "Add"
      );
      this.$mdDialog.show(extraSeatConfirm).then(() => {
        this.Ride.extraSeat(this.$stateParams.id).$promise.then(
          (response) => {
            this.ride = this.RideTransforms.justify(response);
            this.Events.emit(
              this.showSuccessNotificationEvent,
              this.Messages.extraSeatMessage()
            );
          },
          (response) => this.Events.emit(this.errorEvent, response.data)
        );
      });
    };

    const arrivedStation = (station) => {
      this.Ride.arrived(this.$stateParams.id, station._id).$promise.then(
        (response) => {
          this.Events.emit(
            this.showSuccessNotificationEvent,
            this.Messages.arriveMessage(station.name)
          );
          this.ride = this.RideTransforms.justify(response);
          this.Events.emit(this.realtimeEvent, this.ride.stationsSchedules);
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    };

    const departedStation = (station) => {
      this.Ride.departed(this.$stateParams.id, station._id).$promise.then(
        (response) => {
          this.Events.emit(
            this.showSuccessNotificationEvent,
            this.Messages.departMessage(station.name)
          );
          this.ride = this.RideTransforms.justify(response);
          this.Events.emit(this.realtimeEvent, this.ride.stationsSchedules);
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    };

    this.cancelRide = () => {
      const cancel = this.$mdDialog.show({
        controller: cancelReasonsDialogCtrl,
        controllerAs: "$ctrl",
        template: cancelReasonsDialog,
        clickOutsideToClose: true,
        locals: {
          ride: this.ride,
          isCorporateRevised: this.isCorporateRevised,
          bookingsUsers: this.bookingsUsers,
        },
      });

      cancel.then((data) => {
        this.Ride.cancel(this.$stateParams.id, {
          reason: data.reason,
        }).$promise.then(
          (response) => {
            this.ride = this.RideTransforms.justify(response);
            this.isCancelled = response.status.name === "cancelled";
            this.Events.emit(
              this.showSuccessNotificationEvent,
              this.Messages.cancelRideMessage()
            );
          },
          (response) => this.Events.emit(this.errorEvent, response.data)
        );
      });
    };
    this.transferBookingsUpdated = () => {
      this.$mdDialog.show({
        controller: transferBookingsUpdatedDialogCtrl,
        controllerAs: "$ctrl",
        template: transferBookingsUpdatedDialog,
        clickOutsideToClose: true,
        locals: {
          ride: this.rideID,
          routeName: this.ride.route.name,
        },
      });
    };
    this.lockDynamicRide = () => {
      this.Ride.lockDynamicRide(this.ride.roudyna_ride_id.value)
        .$promise.then((res) => {
          this.ride = this.RideTransforms.justify(res);
          this.Events.emit(this.showSuccessNotificationEvent, {
            message: "Ride Locked Successfully",
          });
        })
        .catch((err) => this.Events.emit(this.errorEvent, err.data));
    };
    this.handleEnable = () => {
      const isActive = this.ride.active.value;
      const message = isActive ? "disable" : "enable";
      const confirm = this.$mdDialog
        .confirm()
        .title(
          `Are you sure you want to ${message} "${this.ride.route.name}" ride?`
        )
        .ok(message)
        .cancel("Cancel");

      this.$mdDialog.show(confirm).then(
        () => {
          const active = !this.ride.active.value;
          const method = isActive ? "disable" : "enable";

          this.Ride[method](this.$stateParams.id, { active }).$promise.then(
            (response) => {
              this.ride = this.RideTransforms.justify(response);
              this.Events.emit(
                this.showSuccessNotificationEvent,
                this.Messages.enableRideMessage("ride", message)
              );
            }
          );
        },
        () => {}
      );
    };

    this.endRide = () => {
      const message = this.ride.coming_stations.length
        ? "skip remaining stations"
        : "end this ride?";
      const confirm = this.$mdDialog
        .confirm()
        .title(`Are you sure you want to ${message}`)
        .ok("Ok")
        .cancel("Cancel");

      // NOTE: don't allow end ride before starting the ride
      // starting ride = (past_stations > 0)
      if (
        this.ride.past_stations.length === 0 &&
        !this.ride.stations_data.every((s) => s.status === "skipped")
      ) {
        this.Events.emit(this.errorEvent, { message: `can't ${message}..` });
      } else {
        this.$mdDialog.show(confirm).then(
          () => {
            this.Ride.end(this.$stateParams.id).$promise.then(
              (response) => {
                this.ride = this.RideTransforms.justify(response);
                this.Events.emit(
                  this.showSuccessNotificationEvent,
                  this.Messages.endRideMessage()
                );
              },
              (response) => this.Events.emit(this.errorEvent, response.data)
            );
          },
          () => {}
        );
      }
    };

    this.seatToMax = () => {
      const confirm = this.$mdDialog
        .confirm()
        .title("Are you sure you want to set seats to maximum?")
        .ok("Ok")
        .cancel("Cancel");
      this.$mdDialog.show(confirm).then(
        () => {
          this.Ride.seatsToMax(this.$stateParams.id)
            .$promise.then((response) => {
              this.ride = this.RideTransforms.justify(response);
              this.Events.emit(
                this.showSuccessNotificationEvent,
                this.Messages.seatsToMaxMessage()
              );
            })
            .catch((err) => {
              this.Events.emit(this.errorEvent, err.data);
            });
        },
        () => {}
      );
    };

    this.flagAsEmergency = () => {
      const confirm = this.$mdDialog
        .confirm()
        .title("Are you sure you want to flag this ride as emergency?")
        .ok("Ok")
        .cancel("Cancel");

      this.$mdDialog.show(confirm).then(
        () => {
          this.Ride.emergency(this.$stateParams.id).$promise.then(
            (response) => {
              this.ride = this.RideTransforms.justify(response);
              this.Events.emit(
                this.showSuccessNotificationEvent,
                this.Messages.emergencyMessage()
              );
            },
            (response) => this.Events.emit(this.errorEvent, response.data)
          );
        },
        () => {}
      );
    };

    this.removeEmergency = () => {
      const confirm = this.$mdDialog
        .confirm()
        .title("Are you sure you want to remove emergency flag for this ride?")
        .ok("Ok")
        .cancel("Cancel");

      this.$mdDialog.show(confirm).then(
        () => {
          this.Ride.unmarkEmergency(this.$stateParams.id).$promise.then(
            (response) => {
              this.ride = this.RideTransforms.justify(response);
              this.Events.emit(
                this.showSuccessNotificationEvent,
                this.Messages.removeEmergencyMessage()
              );
            },
            (response) => this.Events.emit(this.errorEvent, response.data)
          );
        },
        () => {}
      );
    };

    this.startRide = () => {
      const confirm = this.$mdDialog
        .confirm()
        .title("Are you sure you want to start this ride?")
        .ok("Ok")
        .cancel("Cancel");

      this.$mdDialog.show(confirm).then(
        () => {
          this.Ride.departed(this.$stateParams.id).$promise.then(
            (response) => {
              this.ride = this.RideTransforms.justify(response);
              this.Events.emit(this.showSuccessNotificationEvent, {
                message: "Ride started successfully.",
              });
            },
            (response) => this.Events.emit(this.errorEvent, response.data)
          );
        },
        () => {}
      );
    };

    this.book = () => {
      const book = this.$mdDialog.show({
        controller: bookDialogCtrl,
        controllerAs: "$ctrl",
        template: bookDialog,
        locals: {
          availableStations: this.ride.coming_stations,
          ride: this.ride,
        },
      });

      book.then((data) => {
        data.ride = this.ride._id.value;
        this.Bookings.post(data).$promise.then(
          () => {
            this.Events.emit(this.showSuccessNotificationEvent, {
              message: "Booking added successfully.",
            });
          },
          (response) =>
            this.Events.emit(this.Events.eventsType.onShowErrorNotification, {
              message:
                response.data.user_message_body_i18n &&
                response.data.user_message_body_i18n.en
                  ? response.data.user_message_body_i18n.en
                  : response.data.message,
            })
        );
      });
    };

    this.assignBackup = () => {
      const assign = this.$mdDialog.show({
        controller: assignBackupDialog,
        controllerAs: "$ctrl",
        template: assignBackupDialogCtrl,
        clickOutsideToClose: true,
        locals: {
          ride: this.ride,
        },
      });

      assign.then((data) => {
        this.Ride.assignBackup(this.$stateParams.id, data).$promise.then(
          (response) => {
            this.Events.emit(this.showSuccessNotificationEvent, {
              message: "Backup assigned successfully.",
            });
            this.ride = this.RideTransforms.justify(response);
          },
          (response) => {
            if (response.data.captainConflict) {
              const captainConflict = response.data.captainConflict;
              this.showConflictDialog(captainConflict);
            }
            this.Events.emit(this.errorEvent, response.data);
          }
        );
      });
    };
    this.unAssignCaptain = () => {
      const unAssign = this.$mdDialog.show({
        controller: unAssignCaptainDialogCtrl,
        controllerAs: "$ctrl",
        template: unAssignCaptainDialog,
        locals: {
          ride: this.ride,
        },
      });
      unAssign.then((data) => {
        this.Ride.unAssignCaptain(this.$stateParams.id, data).$promise.then(
          (response) => {
            this.Events.emit(this.showSuccessNotificationEvent, {
              message: "Captain Unassigned Successfully.",
            });
            this.ride = this.RideTransforms.justify(response);
          },
          (response) => this.Events.emit(this.errorEvent, response.data)
        );
      });
    };

    this.assignCaptain = () => {
      const dismiss = this.$mdDialog.show({
        controller: captainInfoDialogCtrl,
        controllerAs: "$ctrl",
        template: captainInfoDialog,
        clickOutsideToClose: true,
        locals: {
          ride: this.ride,
        },
      });

      dismiss.then((data) => {
        this.Ride.assignCaptain(this.$stateParams.id, data).$promise.then(
          (response) => {
            this.Events.emit(this.showSuccessNotificationEvent, {
              message: "Changed successfully.",
            });
            this.ride = this.RideTransforms.justify(response);
          },
          (response) => {
            if (response.data.captainConflict) {
              const captainConflict = response.data.captainConflict;
              this.showConflictDialog(captainConflict);
            }
            this.Events.emit(this.errorEvent, response.data);
          }
        );
      });
    };

    this.assignVendor = () => {
      const dismiss = this.$mdDialog.show({
        controller: vendorInfoDialogCtrl,
        controllerAs: "$ctrl",
        template: vendorInfoDialog,
        clickOutsideToClose: true,
        locals: {
          ride: this.ride,
        },
      });

      dismiss.then((data) => {
        this.Ride.assignVendor(this.$stateParams.id, data).$promise.then(
          (response) => {
            this.Events.emit(this.showSuccessNotificationEvent, {
              message: "Changed successfully.",
            });
            this.ride = this.RideTransforms.justify(response);
          },
          (response) => {
            if (response.data.captainConflict) {
              const captainConflict = response.data.captainConflict;
              this.showConflictDialog(captainConflict);
            }
            this.Events.emit(this.errorEvent, response.data);
          }
        );
      });
    };

    this.createInvoiceItem = () => {
      const ride = this.$stateParams.id;
      const type = "ride";

      this.InvoiceItem.post({ ride, type }).$promise.then(
        () => {
          this.Events.emit(this.showSuccessNotificationEvent, {
            message: "Invoice Item created successfully.",
          });
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    };

    this.$transitions.onStart({}, () => {
      socket.disconnect();
    });

    this.getActiveContract = (corporateId) => {
      return this.Contracts.getActive({
        corporateId,
      });
    };

    this.Ride.get(this.$stateParams.id)
      .$promise.then(
        (response) => {
          // Show bookings fields based on the ride type
          this.bookingsFields = response.is_dynamic
            ? this.BookingsTransforms.dynamicRideBookingsFields
            : this.BookingsTransforms.insideFields;
          this.ride = this.RideTransforms.justify(response);
          this.decodedPolyline = polyline.decode(response.route.polyline);
          this.rideStatus = response.status.name;
          this.price = this.ride.price.value + " " + this.ride.currency.value;
          this.isCorporateRevised =
            response.status.name === "corporate_revised";
          this.isCancelled = response.status.name === "cancelled";
          this.stations = this.ride.past_stations.concat(
            this.ride.coming_stations
          );
          if (!isNil(this.ride.captain) && !isNil(this.ride.captain.company)) {
            this.Company.get(this.ride.captain.company).$promise.then((res) => {
              this.captainCompany = res.name;
            });
          }
          if (this.ride.corporates.length > 0) {
            this.getActiveContract(this.ride.corporates[0]._id)
              .$promise.then((res) => {
                this.activeContract = res;
                this.manualRideFields = this.RideTransforms.getManualRideOptions(
                  this.ride,
                  this.activeContract
                );
                // Prefill ride price
                this.Events.emit(this.RideTransforms.onSelectBusTypeEvent);
              })
              .catch(() => {
                this.manualRideFields = this.RideTransforms.getManualRideOptions(
                  this.ride
                );
              });
          }
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      )
      .then(() => {
        if (this.rideStatus === "started" || this.rideStatus === "stopped") {
          socket.on("connect", () => {
            this.$timeout(() =>
              socket.emit("ride:subscribe", { rideId: this.$stateParams.id })
            );
          });
          if (socket.connected === true) {
            this.$timeout(() => {
              this.Events.emit(
                this.connectionStatusEvent,
                connectionStatusSuccess
              );
              socket.emit("ride:subscribe", { rideId: this.$stateParams.id });
            });
          }
        } else {
          socket.disconnect();
        }
      });

    this.cancelAndCreateManualRide = () => {
      this.getRideCategory(this.dashboardCity);

      const dialog = this.$mdDialog.show({
        controller: DialogController,
        controllerAs: "$ctrl",
        template: DialogTemplate,
        locals: {
          options: this.manualRideFields,
          // This is nonsense but haaaa
          selectedDays: null,
        },
      });

      dialog.then((data) => {
        const request = {};
        data.fields.forEach((field) => {
          if (isObject(field.value) && field.name !== "date") {
            Object.assign(request, { [field.name]: field.value._id });
          } else if (field.name === "ride_price") {
            Object.assign(request, {
              [field.name]: field.value * constants.currencyBy,
            });
          } else Object.assign(request, { [field.name]: field.value });
        });
        const confirmationDialog = getConfirmDialog(
          `You will cancel the ride of ${this.ride.bookings.count} bookings and create new manual one`
        );
        this.$mdDialog.show(confirmationDialog).then(() => {
          this.Ride.createManualRide(
            this.$stateParams.id,
            request
          ).$promise.then(
            () => {
              this.Events.emit(
                this.showSuccessNotificationEvent,
                this.Messages.createManualRideMessage()
              );
            },
            (response) => this.Events.emit(this.errorEvent, response.data)
          );
        });
      });
    };
    this.Ride.cashCollection(this.$stateParams.id).$promise.then(
      (response) => {
        this.cashReport = response.transactions;
        this.totalCashReport = this.RideTransforms.getCashCollectionSum(
          this.cashReport
        );
      },
      () => {}
    );

    socket.on("ride:update", (data) => {
      this.ride = this.RealtimeRide.check(data, this.ride);
      this.Events.emit(this.realtimeEvent, this.ride.stationsSchedules);
    });

    socket.on("ride:location:update", (data) => {
      this.$timeout(() => this.Events.emit(rideLocationEvent, data.location));
    });

    socket.on("dashboard:connected", () => {
      this.$timeout(() =>
        this.Events.emit(this.connectionStatusEvent, connectionStatusSuccess)
      );
    });

    socket.on("connect_error", () => {
      this.Events.emit(this.connectionStatusEvent, connectionStatusError);
    });

    socket.on("connect_failed", () => {
      this.Events.emit(this.connectionStatusEvent, connectionStatusError);
    });

    socket.on("disconnect", () => {
      this.Events.emit(this.connectionStatusEvent, connectionStatusError);
    });

    socket.on("reconnect_attempt", () => {
      const transports =
        process.env.NODE_ENV === "production"
          ? ["websocket"]
          : ["polling", "websocket"];
      socket.io.opts.transports = transports;
    });

    const skipStation = (stationName) => {
      this.Ride.skipStation(this.$stateParams.id).$promise.then(
        (response) => {
          this.Events.emit(this.showSuccessNotificationEvent, {
            message: `You marked "${stationName}" as skipped successfully.`,
          });

          this.ride = this.RideTransforms.justify(response);
          this.Events.emit(this.realtimeEvent, this.ride.stationsSchedules);
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    };

    getBooking();
    this.Events.on(this.onUpdate, onUpdate);
    // This.Events.on(this.onTransfer, transferSuggestions);
    this.Events.on(this.onArrived, arrivedStation);
    this.Events.on(this.onDeparted, departedStation);
    this.Events.on(this.skipStationEvent, skipStation);
  }

  getRideCategory(city) {
    const param = {};
    if (!isNil(city)) {
      param.city = city._id;
    }
    this.Lists.all.rideCategoryList = [];
    this.City.getRideCategory(param).$promise.then((response) => {
      if (response.hits) {
        this.Lists.all.rideCategoryList = response.hits.map(
          ({ _id: name, _source: category }) => ({
            name,
            title: `${category.ride_type} ${category.service_type}`,
          })
        );
      }
    });
  }

  assignBus() {
    const assign = this.$mdDialog.show({
      controller: assignBusDialogCtrl,
      controllerAs: "$ctrl",
      template: assignBusDialogTemplate,
      locals: {
        ride: this.ride,
      },
      clickOutsideToClose: true,
    });

    assign.then((data) => {
      this.Ride.assignBus(this.$stateParams.id, data).$promise.then(
        (response) => {
          this.Events.emit(this.showSuccessNotificationEvent, {
            message: "Bus assigned successfully.",
          });
          this.ride = this.RideTransforms.justify(response);
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    });
  }

  $onDestroy() {
    this.$mdDialog.cancel();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/ride/ride.controller.js